export default __webpack_public_path__ + "static/media/programme1.b60b3f88.webp";